import {SelectOptionsType} from 'global';
import {useDebounceEffect, useGetAllSprints} from 'hooks';
import {useCallback, useMemo} from 'react';
import {AppControlledAutoComplete, AppControlledAutoCompleteProps} from './AutoComplete';

export interface AppSprintSelectProps extends Omit<AppControlledAutoCompleteProps, 'options' | 'value'> {
    boardSlug?: string;
}
export const AppSprintSelect = ({boardSlug, disableClearable, ...props}: AppSprintSelectProps) => {
    const {getAllSprints, getAllSprintsLoading, getAllSprintsResponse} = useGetAllSprints();

    const handleNext = useCallback(() => {
        if (boardSlug && getAllSprintsResponse?.pageInfo.hasNextPage) {
            getAllSprints({
                variables: {
                    boardId: boardSlug,
                    after: getAllSprintsResponse?.pageInfo.endCursor,
                    first: 50,
                },
            });
        }
    }, [boardSlug, getAllSprints, getAllSprintsResponse?.pageInfo.endCursor]);

    useDebounceEffect(
        () => {
            if (boardSlug) {
                getAllSprints({
                    variables: {
                        boardId: boardSlug,
                        first: 50,
                    },
                });
            }
        },
        [boardSlug],
        500,
    );

    const sprintOptions: SelectOptionsType[] = useMemo(() => {
        if (getAllSprintsResponse) {
            return [
                {
                    label: 'No Sprint',
                    value: '',
                },
                ...getAllSprintsResponse.nodes.map(
                    x =>
                        ({
                            label: x.title,
                            value: x.id,
                        }) as SelectOptionsType,
                ),
            ];
        }
        return [];
    }, [getAllSprintsResponse]);

    return (
        <AppControlledAutoComplete
            loading={getAllSprintsLoading}
            options={sprintOptions}
            disableClearable={disableClearable}
            onScrollBottomHandler={handleNext}
            {...props}
        />
    );
};

export default AppSprintSelect;
